export default () => ({
  actions: {
    drag: 'Drag and drop files here or ',
    browse: 'browse files'
  }
});
